export const requestStates = {
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  EXECUTED: 'EXECUTED',
  REJECTED: 'REJECTED',
  HUNG: 'HUNG',
}
